import { USE_CASES, PLATFORM_USE_CASES, CUSTOM_USE_CASES } from '../constants/useCases';
import type { OfferingType, UseCaseKey } from '../types';

interface Props {
  offering: OfferingType;
  selected: Set<UseCaseKey>;
  onToggle: (key: UseCaseKey) => void;
}

export function UseCaseSelector({ offering, selected, onToggle }: Props) {
  const list = offering === 'platform' ? PLATFORM_USE_CASES : CUSTOM_USE_CASES.filter(k => k !== 'custom');
  const customKey: UseCaseKey | null = offering === 'custom' ? 'custom' : null;

  return (
    <div className="card">
      <p style={{ fontSize: 12, color: 'var(--text-dim)', marginBottom: 15, lineHeight: 1.6 }}>
        Select ONE use case for this request. Current automation supports a
        single use case per RITM; multi-select will be enabled once orchestration
        is generalized.
      </p>
      <div className="uc-grid" role="group">
        <div className="uc-grp">
          {offering === 'platform'
            ? 'Standard Platform Use Cases — Metrics / Logs'
            : 'Custom Application Use Cases'}
        </div>
        {list.map(k => (
          <UseCaseCard key={k} ucKey={k} selected={selected.has(k)} onToggle={onToggle} />
        ))}
        {customKey && (
          <>
            <div className="uc-grp">Custom / Other — Template Upload</div>
            <UseCaseCard ucKey={customKey} selected={selected.has(customKey)} onToggle={onToggle} dashed />
          </>
        )}
      </div>
    </div>
  );
}

function UseCaseCard({
  ucKey,
  selected,
  onToggle,
  dashed,
}: {
  ucKey: UseCaseKey;
  selected: boolean;
  onToggle: (k: UseCaseKey) => void;
  dashed?: boolean;
}) {
  const def = USE_CASES[ucKey];
  return (
    <button
      type="button"
      className={`uc-card${selected ? ' sel' : ''}${dashed ? ' dashed' : ''}`}
      style={
        {
          '--uc-color': def.color,
          '--uc-rgb': def.rgb,
        } as React.CSSProperties
      }
      onClick={() => onToggle(ucKey)}
      aria-pressed={selected}
    >
      <div className="uc-ico" aria-hidden>{def.icon}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="uc-name">{def.label}</div>
        <div className="uc-desc">{def.subtitle}</div>
        <div className="uc-tag">{def.tag}</div>
      </div>
      <div className="uc-chk" aria-hidden>●</div>
    </button>
  );
}
